/**
 * @fileoverview NotesToggleButton Component
 * 
 * A reusable button component for toggling the notes panel in meeting interfaces.
 * Features dynamic icon color and tooltip text based on the notes panel state.
 */

import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";

interface NotesToggleButtonProps {
  /** Whether the notes panel is currently open */
  isOpen: boolean;
  /** Callback function to toggle the notes panel */
  onToggle: () => void;
}

/**
 * NotesToggleButton - A button for toggling the notes panel visibility
 * 
 * @param isOpen - Current state of the notes panel
 * @param onToggle - Function to call when the button is clicked
 */
const NotesToggleButton: React.FC<NotesToggleButtonProps> = ({ 
  isOpen, 
  onToggle 
}) => {
  return (
    <Tooltip title={isOpen ? "Close Notes" : "Open Notes"}>
      <IconButton
        onClick={onToggle}
        sx={{ color: isOpen ? 'primary.main' : '#666' }}
      >
        <DescriptionIcon />
      </IconButton>
    </Tooltip>
  );
};

export default NotesToggleButton;
